import _implicitStylesheets from "./results.css";
import _implicitScopedStylesheets from "./results.scoped.css?scoped=true";
import _wdsCardGrid from "wds/cardGrid";
import _wdsError from "wds/error";
import _wdsErrorBanner from "wds/errorBanner";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="img-empty-stage${0}"${2}><img${"a1:src"}${"a1:alt"}${3}></div>`;
const $fragment2 = parseFragment`<span class="no-results${0}" data-testid="no-results"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<div class="trending-search-title${0}"${2}>${"t1"}</div>`;
const $fragment4 = parseFragment`<div class="trending-search-title${0}"${2}>${"t1"}</div>`;
const $fragment5 = parseFragment`<div class="img-empty-stage${0}"${2}><img${"a1:src"}${3}></div>`;
const $fragment6 = parseFragment`<span class="no-results${0}" data-testid="no-results"${2}>${"t1"}</span>`;
const $fragment7 = parseFragment`<p class="trending-search-title${0}"${2}>${"t1"}</p>`;
const $fragment8 = parseFragment`<div class="img-empty-stage${0}"${2}><img${"a1:src"}${3}></div>`;
const $fragment9 = parseFragment`<span class="no-results${0}" data-testid="no-results"${2}>${"t1"}</span>`;
const $fragment10 = parseFragment`<p class="trending-search-title${0}"${2}>${"t1"}</p>`;
const stc0 = {
  "listings": true
};
const stc1 = {
  classMap: {
    "headers": true
  },
  attrs: {
    "util-style": "",
    "type-style": "display-8"
  },
  key: 1
};
const stc2 = {
  key: 2
};
const stc3 = [];
const stc4 = {
  "sponsored-tiles": true
};
const stc5 = {
  classMap: {
    "headers": true
  },
  attrs: {
    "util-style": "",
    "type-style": "display-8"
  },
  key: 4
};
const stc6 = {
  key: 5
};
const stc7 = {
  "listings-grid": true
};
const stc8 = {
  attrs: {
    "data-testid": "error-result"
  },
  key: 7
};
const stc9 = {
  classMap: {
    "error-banner": true
  },
  key: 9
};
const stc10 = {
  key: 11
};
const stc11 = {
  "show-more-btn": true
};
const stc12 = {
  "data-testid": "view-more-button"
};
const stc13 = {
  classMap: {
    "empty-state-container": true
  },
  key: 13
};
const stc14 = {
  classMap: {
    "empty-state-container": true
  },
  key: 22
};
const stc15 = {
  classMap: {
    "btn-empty-stage": true
  },
  key: 29
};
const stc16 = {
  classMap: {
    "empty-state-container": true
  },
  key: 31
};
const stc17 = {
  classMap: {
    "btn-empty-stage": true
  },
  key: 38
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, d: api_dynamic_text, t: api_text, s: api_slot, h: api_element, c: api_custom_element, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [!$cmp.isSearchResultEmpty ? api_element("div", {
    classMap: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [$cmp.showSponsoredTiles ? api_element("h2", stc1, [api_text(api_dynamic_text($cmp.labels.listingTiles.sponsoredTitle)), api_slot("", stc2, stc3, $slotset)]) : null, $cmp.showSponsoredTiles ? api_custom_element("wds-card-grid", _wdsCardGrid, {
    classMap: stc4,
    props: {
      "listingRecords": $cmp.sponsoredListings,
      "isLoading": $cmp.isInitialLoading,
      "skeletonCount": "2",
      "columnSize": "4:4@x-small 4:8@medium",
      "columnGap": "large"
    },
    key: 3
  }) : null, $cmp.showSponsoredTiles ? $cmp.showListingTiles ? api_element("h2", stc5, [api_text(api_dynamic_text($cmp.listingTilesTitle)), api_slot("", stc6, stc3, $slotset)]) : null : null, api_custom_element("wds-card-grid", _wdsCardGrid, {
    classMap: stc7,
    props: {
      "listingRecords": $cmp.searchListings,
      "isLoading": $cmp.isLoading,
      "skeletonCount": "6",
      "columnSize": "4:4@x-small 4:8@medium",
      "columnGap": "large",
      "cardFocusIdx": $cmp.cardFocusIdx,
      "navigatedWithKeyboard": $cmp.navigatedWithKeyboard
    },
    key: 6
  }), $cmp.isInitialError ? api_element("div", stc8, [api_custom_element("wds-error", _wdsError, {
    props: {
      "titleLabel": $cmp.errorTitleLabel,
      "descriptionLabel": $cmp.errorDescriptionLabel,
      "handleButtonClick": $cmp.handleTilesRetry
    },
    key: 8
  })]) : null]) : null, !$cmp.isSearchResultEmpty ? $cmp.shouldShowErrorBanner ? api_element("div", stc9, [api_custom_element("wds-error-banner", _wdsErrorBanner, {
    props: {
      "error": $cmp.labels.viewMoreError
    },
    key: 10,
    on: {
      "close": _m1 || ($ctx._m1 = api_bind($cmp.handleErrorClosed))
    }
  })]) : null : null, !$cmp.isSearchResultEmpty ? $cmp.shouldShowLoadMore ? api_element("div", stc10, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc11,
    attrs: stc12,
    props: {
      "name": "view more",
      "label": $cmp.labels.viewMore,
      "width": "fill",
      "variant": "secondary",
      "disabled": $cmp.isLoading
    },
    key: 12,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleLoadMore)),
      "analytics": _m3 || ($ctx._m3 = api_bind($cmp.handleAnalytics))
    }
  })]) : null : null, $cmp.isSearchResultEmpty ? $cmp.noResults ? api_element("div", stc13, [api_static_fragment($fragment1, 15, [api_static_part(1, {
    attrs: {
      "src": $cmp.errorEmptyStateImageUrl,
      "alt": $cmp.labels.emptyState.allEmpty.altText
    }
  }, null)]), api_static_fragment($fragment2, 17, [api_static_part(1, null, api_dynamic_text($cmp.labels.emptyState.allEmpty.title))]), $cmp.keyword ? api_static_fragment($fragment3, 19, [api_static_part(1, null, api_dynamic_text($cmp.labels.emptyState.allEmpty.suggestion))]) : null, !$cmp.keyword ? api_static_fragment($fragment4, 21, [api_static_part(1, null, api_dynamic_text($cmp.labels.emptyState.allEmpty.keywordlessSearchSuggestion))]) : null]) : null : null, $cmp.isSearchResultEmpty ? !$cmp.noResults ? $cmp.appsResultsEmpty ? api_element("div", stc14, [api_static_fragment($fragment5, 24, [api_static_part(1, {
    attrs: {
      "src": $cmp.errorEmptyStateImageUrl
    }
  }, null)]), api_static_fragment($fragment6, 26, [api_static_part(1, null, api_dynamic_text($cmp.labels.emptyState.hasOtherResults.noApps.title))]), api_static_fragment($fragment7, 28, [api_static_part(1, null, api_dynamic_text($cmp.labels.emptyState.hasOtherResults.noApps.suggestion))]), api_element("div", stc15, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "name": "showResultsButton",
      "label": $cmp.labels.emptyState.hasOtherResults.buttonText
    },
    key: 30,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.handleSwitch))
    }
  })])]) : null : null : null, $cmp.isSearchResultEmpty ? !$cmp.noResults ? $cmp.consultantsResultsEmpty ? api_element("div", stc16, [api_static_fragment($fragment8, 33, [api_static_part(1, {
    attrs: {
      "src": $cmp.errorEmptyStateImageUrl
    }
  }, null)]), api_static_fragment($fragment9, 35, [api_static_part(1, null, api_dynamic_text($cmp.labels.emptyState.hasOtherResults.noConsultants.title))]), api_static_fragment($fragment10, 37, [api_static_part(1, null, api_dynamic_text($cmp.labels.emptyState.hasOtherResults.noConsultants.suggestion))]), api_element("div", stc17, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "name": "showResultsButton",
      "label": $cmp.labels.emptyState.hasOtherResults.buttonText
    },
    key: 39,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleSwitch))
    }
  })])]) : null : null : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-644lbo6ofk0";
tmpl.legacyStylesheetToken = "undefined-_results";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
